import { ReactNode } from 'react';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

import { TiaraPageKey } from '@/constants/tiara';

export type AlertPopupProps = {
  tiaraPageKey?: TiaraPageKey;
  headerText?: ReactNode;
  bodyText: ReactNode;
  confirmButtonText?: string;
  cancelButtonText?: string;
  shouldCloseAfterConfirm?: boolean;
  onConfirm?: () => Promise<void> | void;
  onCancel?: () => Promise<void> | void;
};

type ErrorPopupProps = Pick<AlertPopupProps, 'headerText' | 'bodyText' | 'onConfirm'>;

type AlertPopupState = AlertPopupProps & {
  isOpen: boolean;
};

type AlertPopupAction = {
  openAlertPopup: (props: AlertPopupProps) => void;
  openErrorPopup: (props: ErrorPopupProps) => void;
  closeAlertPopup: () => void;
};

const INIT_ALERT_POPUP_STATE: AlertPopupState = {
  tiaraPageKey: undefined,
  headerText: '',
  bodyText: '',
  confirmButtonText: '',
  cancelButtonText: '',
  shouldCloseAfterConfirm: true,
  onConfirm: undefined,
  onCancel: undefined,
  isOpen: false
};

export const useAlertPopupStore = createWithEqualityFn<AlertPopupState & AlertPopupAction>()(
  (set) => ({
    ...INIT_ALERT_POPUP_STATE,
    openAlertPopup: (props: AlertPopupProps) => {
      set({
        ...INIT_ALERT_POPUP_STATE,
        ...props,
        isOpen: true
      });
    },
    openErrorPopup: ({ headerText, bodyText, onConfirm }) => {
      set({
        ...INIT_ALERT_POPUP_STATE,
        headerText,
        bodyText,
        onConfirm,
        confirmButtonText: '확인',
        isOpen: true
      });
    },
    closeAlertPopup: () => {
      set({ ...INIT_ALERT_POPUP_STATE });
    }
  }),
  shallow
);
